export default __webpack_public_path__ + "static/media/prototype_rancour.64965f56.png";